import type { FaireProductEntity } from "../../entity_types/product";

export const p_6c5blstgxr: FaireProductEntity = {
  token: "p_6c5blstgxr",
  type: "product",
  name: "Large Recycled LP Vinyl Record Journal",
  brandToken: "b_1f6d1f6b",
  brandName: "Vinylux",
  imageUrl: "https://cdn.faire.com/fastly/be89f4b4ad8962ebab9c9d8d98e47e858e175c51a6a36aed3cc1c81aac469fd1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d863b83577a8df061376be6ccaf6ccd0b8a1bbba64a805a39c6edd3d2fd3a38.jpeg",
    "https://cdn.faire.com/fastly/e309b956c27a2b6b679cd89511a56990c97e9e46b9d1faf3b018dd509db4d81c.jpeg",
    "https://cdn.faire.com/fastly/d4b4f34490ce964d7d4c3ad199549c96a63bd6e1d618c0fe3ae378cb325750de.jpeg",
    "https://cdn.faire.com/fastly/aefb6bf5a8ad8a67b5a00c0402b9500ec957e797c4c76668283411401ac62c3a.jpeg"
  ],
  priceDollars: 12.5,
  description: "The cover of these full-size journals are made from recycled 12\" vinyl records with an authentic vintage record label on the front cover! Each journal features an elastic strap closure and 160 pages of lined paper, with a smooth faux leather spine and back cover. These groovy journals measure 5.5\" wide x 8.25\" tall, with a thickness of 1/2\".\n\nGreat for:\n- Graduation & Back to School\n- Conferences\n- Field Notes\n- Gifts for Music Lovers\n- Eco-Friendly Gifts\n\nCase packs of our Vinyl Record Journals contain an exciting mix of artists and genres including Rock, Soul, Jazz, 70s/80s Pop, Hip Hop, Country, Classical, Showtunes and more!  Your collection of journals is curated by our talented team of artisans; there is no choice of musical genre or artist for this product.\n\nHandmade in Philadelphia, PA.\n\nReturns/exchanges only for damaged or missing items.",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:31:40.087Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
